export class SVG_UTILITIES {

    // SVG_NS_NS = SVG NameSpace
    // SVG_NS_NS = SVG NameSpace
    // SVG_NS_NS = SVG NameSpace
    // SVG_NS_NS = SVG NameSpace
    public static readonly SVG_NS: string = "http://www.w3.org/2000/svg";

    public static get_or_create_defs(p_svg_element: SVGSVGElement): SVGDefsElement {
        if ((p_svg_element instanceof SVGSVGElement) == false) {
            alert("Error: The object passed to the function is not a valid SVGSVGElement.");
            throw new Error("Invalid SVGSVGElement passed to get_or_create_defs");
        }

        let current_defs = p_svg_element.querySelector("defs") as SVGDefsElement;
        if (current_defs != null) {
            // defs already exists. return it
            return current_defs;
        }
        else {
            // defs does not exist. we need to create it
            const first_child = p_svg_element.firstChild;
            const created_defs = document.createElementNS(this.SVG_NS, "defs") as SVGDefsElement;
            if (first_child != null) {
                p_svg_element.insertBefore(created_defs, first_child);
            }
            else {
                // first_child==null, i.e. p_svg_element has no children
                // gemini what do i put here
                p_svg_element.appendChild(created_defs);
            }
            return created_defs;
        }
    }


    public static get_element_by_id(p_svg_element: SVGSVGElement, p_id: string): Element | null {
        // Defensive check at runtime for the input element itself
        if (!(p_svg_element instanceof SVGSVGElement)) {
            alert("Error: The object passed to the function is not a valid SVGSVGElement.");
            throw new Error("Invalid SVGSVGElement passed to get_element_by_id");
        }

        const document_owner = p_svg_element.ownerDocument;
        if (document_owner === null) {
            alert("Error: p_svg_element does not have a valid ownerDocument.");
            throw new Error("Missing ownerDocument in get_element_by_id");
        }

        // Splitting into a separate variable for easy debugging and inspection
        const found_element = document_owner.getElementById(p_id);

        if (found_element === null) {
            return null;
        }

        return found_element;
    }

    public static create_marker_in_defs_6x6(p_svg_element: SVGSVGElement, p_color: string): string {
        if (!(p_svg_element instanceof SVGSVGElement)) {
            alert("Error: The object passed to the function is not a valid SVGSVGElement.");
            throw new Error("Invalid SVGSVGElement passed to create_marker_in_defs_6x6");
        }

        const defs = this.get_or_create_defs(p_svg_element);
        const marker_id = `id-arrow-tip-6x6-${p_color}`;

        const existing_marker = this.get_element_by_id(p_svg_element, marker_id);
        if (existing_marker !== null) {
            return marker_id;
        }

        // יש ללמוד את זה בהמשך
        const marker = document.createElementNS(this.SVG_NS, "marker") as SVGMarkerElement;
        marker.setAttribute("id", marker_id);
        marker.setAttribute("viewBox", "0 0 10 10");
        marker.setAttribute("refX", "5");
        marker.setAttribute("refY", "5");
        marker.setAttribute("markerWidth", "6");
        marker.setAttribute("markerHeight", "6");
        marker.setAttribute("orient", "auto-start-reverse");

        const polygon = document.createElementNS(this.SVG_NS, "polygon") as SVGPolygonElement;
        polygon.setAttribute("points", "0 0, 10 5, 0 10");
        polygon.setAttribute("fill", p_color);

        marker.appendChild(polygon);
        defs.appendChild(marker);

        return marker_id;
    }

    public static create_arrow_6x6(p_svg_element: SVGSVGElement, p_x1: number, p_y1: number, p_x2: number, p_y2: number, p_color: string, p_stroke_width: number): SVGLineElement {
        if (!(p_svg_element instanceof SVGSVGElement)) {
            alert("Error: The object passed to the function is not a valid SVGSVGElement.");
            throw new Error("Invalid SVGSVGElement passed to create_arrow_in_svg_6x6");
        }

        const new_line = document.createElementNS(this.SVG_NS, "line") as SVGLineElement;

        new_line.setAttribute("x1", p_x1.toString());
        new_line.setAttribute("y1", p_y1.toString());
        new_line.setAttribute("x2", p_x2.toString());
        new_line.setAttribute("y2", p_y2.toString());
        new_line.setAttribute("stroke", p_color);
        new_line.setAttribute("stroke-width", p_stroke_width.toString());

        // Call the updated marker function which places the resource inside defs
        const marker_id = this.create_marker_in_defs_6x6(p_svg_element, p_color);
        new_line.setAttribute("marker-end", `url(#${marker_id})`);

        //p_svg_element.appendChild(new_line);
        return new_line;
    }



    public static create_minimal_rect_element(): SVGRectElement {
        return document.createElementNS(this.SVG_NS, "rect") as SVGRectElement;
    }

    public static create_minimal_text_element(): SVGTextElement {
        return document.createElementNS(this.SVG_NS, "text") as SVGTextElement;
    }

    public static create_minimal_circle_element(): SVGCircleElement {
        return document.createElementNS(this.SVG_NS, "circle") as SVGCircleElement;
    }

    public static create_minimal_line_element(): SVGLineElement {
        return document.createElementNS(this.SVG_NS, "line") as SVGLineElement;
    }

    public static set_element_width(p_element: SVGElement, p_width: number): void {
        p_element.setAttribute("width", p_width.toString());
    }


    public static set_element_height(p_element: SVGElement, p_height: number): void {
        p_element.setAttribute("height", p_height.toString());
    }


    public static set_element_fill(p_element: SVGElement, p_color: string): void {
        p_element.setAttribute("fill", p_color);
    }

    public static set_element_background_color(p_element: SVGElement, p_color: string): void {
        // אלא color,background-color אין SVG להזכירך שב
        // fill = הצבע עצמו כולל לגבי font
        // stroke - זה הצבע של המסגרת
        this.set_element_fill(p_element, p_color);
    }


    public static set_text_color(p_text_element: SVGTextElement, p_color: string): void {
        // SVGTextElement להזכירך פונקציה זו אמורה לשרת רק
        // SVGTextElement להזכירך פונקציה זו אמורה לשרת רק
        // SVGTextElement להזכירך פונקציה זו אמורה לשרת רק
        if ((p_text_element instanceof SVGTextElement) == false) {
            alert("set_text_color().parameter is not SVGSVGElement.");
            return;
        }
        this.set_element_fill(p_text_element, p_color);
    }

    public static set_element_stroke_color(p_element: SVGElement, p_color: string): void {
        p_element.setAttribute("stroke", p_color);
    }

    public static set_element_stroke_width(p_element: SVGElement, p_width: number): void {
        p_element.setAttribute("stroke-width", p_width.toString());
    }

    public static set_element_x(p_element: SVGElement, p_x: number): void {
        // להזכיר שיש 4 סוגים של פונקציות
        // (1) set_element_x()
        // (2) set_element_y()
        // (3) set_element_cx()
        // (4) set_element_cy()
        p_element.setAttribute("x", p_x.toString());
    }

    public static set_element_y(p_element: SVGElement, p_y: number): void {
        // להזכיר שיש 4 סוגים של פונקציות
        // (1) set_element_x()
        // (2) set_element_y()
        // (3) set_element_cx()
        // (4) set_element_cy()
        p_element.setAttribute("y", p_y.toString());
    }

    public static set_circle_cx(p_circle_element: SVGCircleElement, p_cx: number): void {
        // להזכיר שיש 4 סוגים של פונקציות
        // (1) set_element_x()
        // (2) set_element_y()
        // (3) set_element_cx()
        // (4) set_element_cy()
        p_circle_element.setAttribute("cx", p_cx.toString());
    }

    public static set_circle_cy(p_circle_element: SVGCircleElement, p_cy: number): void {
        // להזכיר שיש 4 סוגים של פונקציות
        // (1) set_element_x()
        // (2) set_element_y()
        // (3) set_element_cx()
        // (4) set_element_cy()
        p_circle_element.setAttribute("cy", p_cy.toString());
    }

    public static set_circle_radius(p_circle_element: SVGCircleElement, p_radius: number): void {
        p_circle_element.setAttribute("r", p_radius.toString());
    }


    public static set_line_x1(p_line_element: SVGLineElement, p_x1: number): void {
        p_line_element.setAttribute("x1", p_x1.toString());
    }

    public static set_line_y1(p_line_element: SVGLineElement, p_y1: number): void {
        p_line_element.setAttribute("y1", p_y1.toString());
    }

    public static set_line_x2(p_line_element: SVGLineElement, p_x2: number): void {
        p_line_element.setAttribute("x2", p_x2.toString());
    }

    public static set_line_y2(p_line_element: SVGLineElement, p_y2: number): void {
        p_line_element.setAttribute("y2", p_y2.toString());
    }

    public static get_view_box_width(p_svg_element: SVGSVGElement): number {
        return p_svg_element.viewBox.baseVal.width;
    }

    public static get_view_box_height(p_svg_element: SVGSVGElement): number {
        return p_svg_element.viewBox.baseVal.height;
    }

    public static set_element_stroke_none(p_element: SVGElement): void {
        p_element.setAttribute("stroke", "none");
    }


    public static position_rect_top_left(p_rect_element: SVGRectElement, leftx: number, topy: number): void {
        if ((p_rect_element instanceof SVGRectElement) == false) {
            alert("pose_rect_element_given_left_top().parameter is not SVGRectElement.");
            return;
        }
        p_rect_element.setAttribute("x", leftx.toString());
        p_rect_element.setAttribute("y", topy.toString());
    }

    public static position_rect_center(p_rect_element: SVGRectElement, centerx: number, centery: number): void {
        if (p_rect_element == null) {
            alert("position_rect_center().parameter is null");
            return;
        }
        if ((p_rect_element instanceof SVGRectElement) == false) {
            alert("position_rect_center().parameter is not SVGRectElement.");
            return;
        }
        const width_str = p_rect_element.getAttribute("width");
        const height_str = p_rect_element.getAttribute("height");
        if (width_str === null || height_str === null) {
            alert("position_rect_center(). width or height attribute is missing.");
            return;
        }
        const width = parseFloat(width_str);
        const height = parseFloat(height_str);
        const leftx = centerx - (width / 2);
        const topy = centery - (height / 2);
        this.position_rect_top_left(p_rect_element, leftx, topy);
    }

    public static position_text(p_text_element: SVGTextElement, x: number, y: number): void {
        if ((p_text_element instanceof SVGTextElement) == false) {
            alert("position_text().parameter is not SVGTextElement.");
            return;
        }
        // תהיה האמצע אז צריך x,y שים לב המיקום של הטקסט נקבע לפי הגדרות של הטקסט. אם למשל רוצהים ש
        //element.setAttribute("text-anchor", "middle");
        //element.setAttribute("dominant-baseline", "central");
        p_text_element.setAttribute("x", x.toString());
        p_text_element.setAttribute("y", y.toString());
    }

    public static position_circle(p_circle_element: SVGCircleElement, centerx: number, centery: number): void {
        if ((p_circle_element instanceof SVGCircleElement) == false) {
            alert("position_circle().parameter is not SVGCircleElement.");
            return;
        }
        p_circle_element.setAttribute("cx", centerx.toString());
        p_circle_element.setAttribute("cy", centery.toString());
    }

    public static get_element_visibility(p_element: SVGElement): boolean {
        if ((p_element instanceof SVGElement) == false) {
            alert("get_element_visibility().parameter is not SVGElement.");
            return false;
        }

        const visibility_str = p_element.getAttribute("visibility");

        // אם המאפיין מוגדר כ-hidden, סימן שהוא מוסתר
        if (visibility_str === "hidden") {
            return false;
        }

        // בכל מקרה אחר (אם הוא "visible" או שעדיין לא הוגדר כלום והוא ברירת מחדל)
        return true;
    }

    public static set_element_visibility(p_element: SVGElement, is_visible: boolean): void {
        if ((p_element instanceof SVGElement) == false) {
            alert("set_element_visibility().parameter is not SVGElement.");
            return;
        }

        const visibility_value_str = is_visible ? "visible" : "hidden";
        p_element.setAttribute("visibility", visibility_value_str);
    }


    //TEMPORARY
    //TEMPORARY
    //TEMPORARY
    public static create_filled_circle(
        // פונקציה זו תפקידה לצייר עיגול מלא בלי מסגרת
        // פונקציה זו תפקידה לצייר עיגול מלא בלי מסגרת
        // פונקציה זו תפקידה לצייר עיגול מלא בלי מסגרת
        svg_element: SVGSVGElement,
        cx: number,
        cy: number,
        radius: number,
        color: string
    ): SVGCircleElement {
        //alert("create_filled_circle()");
        const namespace = "http://www.w3.org/2000/svg";
        const circle = document.createElementNS(namespace, "circle") as SVGCircleElement;

        circle.setAttribute("cx", cx.toString());
        circle.setAttribute("cy", cy.toString());
        circle.setAttribute("r", radius.toString());
        circle.setAttribute("fill", color);
        circle.setAttribute("stroke", "none");

        //svg_element.appendChild(circle);
        return circle;
    }

    //TEMPORARY
    //TEMPORARY
    //TEMPORARY
    public static create_stroked_circle(
        // פונקציה זו תפקידה לצייר עיגול ריק כלומר רק את המסגרת
        // פונקציה זו תפקידה לצייר עיגול ריק כלומר רק את המסגרת
        // פונקציה זו תפקידה לצייר עיגול ריק כלומר רק את המסגרת
        svg_element: SVGSVGElement,
        cx: number,
        cy: number,
        radius: number,
        color: string,
        stroke_width: number = 2
    ): SVGCircleElement {
        const namespace = "http://www.w3.org/2000/svg";
        const circle = document.createElementNS(namespace, "circle") as SVGCircleElement;

        circle.setAttribute("cx", cx.toString());
        circle.setAttribute("cy", cy.toString());
        circle.setAttribute("r", radius.toString());
        circle.setAttribute("fill", "none"); // שקוף מבפנים
        circle.setAttribute("stroke", color); // צבע המסגרת
        circle.setAttribute("stroke-width", stroke_width.toString());

        //svg_element.appendChild(circle);
        return circle;
    }

    //TEMPORARY
    //TEMPORARY
    //TEMPORARY
    public static create_filled_square(
        // פונקציה זו תפקידה לצייר ריבוע/מלבן מלא בלי מסגרת סביב נקודת מרכז
        svg_element: SVGSVGElement,
        cx: number,
        cy: number,
        size: number, // אורך הצלע של הריבוע (או אפשר להפריד ל-width ו-height)
        color: string
    ): SVGRectElement {
        const namespace = "http://www.w3.org/2000/svg";
        const rect = document.createElementNS(namespace, "rect") as SVGRectElement;

        // ב-SVG מלבן מתחיל לפי פינה שמאלית עליונה (x, y). 
        // לכן כדי למרכז אותו סביב (cx, cy) אנחנו מחסירים חצי מהגודל.
        const x = cx - (size / 2);
        const y = cy - (size / 2);

        rect.setAttribute("x", x.toString());
        rect.setAttribute("y", y.toString());
        rect.setAttribute("width", size.toString());
        rect.setAttribute("height", size.toString());
        rect.setAttribute("fill", color);
        rect.setAttribute("stroke", "none");

        svg_element.appendChild(rect);
        return rect;
    }

    //TEMPORARY
    //TEMPORARY
    //TEMPORARY
    public static create_stroked_square(
        // פונקציה זו תפקידה לצייר ריבוע ריק כלומר רק את המסגרת
        svg_element: SVGSVGElement,
        cx: number,
        cy: number,
        size: number, // אורך הצלע של הריבוע
        color: string,
        stroke_width: number = 2
    ): SVGRectElement {
        const namespace = "http://www.w3.org/2000/svg";
        const rect = document.createElementNS(namespace, "rect") as SVGRectElement;

        // חישוב הפינה השמאלית העליונה (x, y) כך שהריבוע יהיה ממומרז סביב (cx, cy)
        const x = cx - (size / 2);
        const y = cy - (size / 2);

        rect.setAttribute("x", x.toString());
        rect.setAttribute("y", y.toString());
        rect.setAttribute("width", size.toString());
        rect.setAttribute("height", size.toString());
        rect.setAttribute("fill", "none"); // שקוף מבפנים
        rect.setAttribute("stroke", color); // צבע המסגרת
        rect.setAttribute("stroke-width", stroke_width.toString());

        //svg_element.appendChild(rect);
        return rect;
    }

    //xxxxxxxx
    public static create_filled_rect(
        // פונקציה זו תפקידה לצייר ריבוע/מלבן מלא בלי מסגרת סביב נקודת מרכז
        svg_element: SVGSVGElement,
        cx: number,
        cy: number,
        size: number, // אורך הצלע של הריבוע (או אפשר להפריד ל-width ו-height)
        color: string
    ): SVGRectElement {
        const namespace = "http://www.w3.org/2000/svg";
        const rect = document.createElementNS(namespace, "rect") as SVGRectElement;

        // ב-SVG מלבן מתחיל לפי פינה שמאלית עליונה (x, y). 
        // לכן כדי למרכז אותו סביב (cx, cy) אנחנו מחסירים חצי מהגודל.
        const x = cx - (size / 2);
        const y = cy - (size / 2);

        rect.setAttribute("x", x.toString());
        rect.setAttribute("y", y.toString());
        rect.setAttribute("width", size.toString());
        rect.setAttribute("height", size.toString());
        rect.setAttribute("fill", color);
        rect.setAttribute("stroke", "none");

        svg_element.appendChild(rect);
        return rect;
    }

    public static get_svg_view_box(p_svg_element: SVGSVGElement): SVGAnimatedRect {
        return p_svg_element.viewBox;
    }

    public static get_svg_view_box_base_val(p_svg_element: SVGSVGElement): SVGRect {
        // viewBox="0 0 600 800" פונקציה זו באה לתת לנו את הערכים של
        // viewBox="0 0 600 800" פונקציה זו באה לתת לנו את הערכים של
        // viewBox="0 0 600 800" פונקציה זו באה לתת לנו את הערכים של
        const svg_animated_rect: SVGAnimatedRect = SVG_UTILITIES.get_svg_view_box(p_svg_element);
        return svg_animated_rect.baseVal;
    }

    public static trans_SVGRect_to_rect(p_svg_rect: SVGRect, p_fill: string, p_stroke: string, p_stroke_width: string): SVGRectElement {
        const new_rect: SVGRectElement = document.createElementNS("http://www.w3.org/2000/svg", "rect");
        new_rect.setAttribute("x", String(p_svg_rect.x));
        new_rect.setAttribute("y", String(p_svg_rect.y));
        new_rect.setAttribute("width", String(p_svg_rect.width));
        new_rect.setAttribute("height", String(p_svg_rect.height));
        new_rect.setAttribute("fill", p_fill);
        new_rect.setAttribute("stroke", p_stroke);
        new_rect.setAttribute("stroke-width", p_stroke_width);
        return new_rect;
    }

    public static create_line(p_svg_element: SVGSVGElement, p_x1: number, p_y1: number, p_x2: number, p_y2: number, p_color: string, p_stroke_width: number): SVGLineElement {
        if (!(p_svg_element instanceof SVGSVGElement)) {
            alert("Error: The object passed to the function is not a valid SVGSVGElement.");
            throw new Error("Invalid SVGSVGElement passed to create_arrow_in_svg_6x6");
        }
        const new_line = document.createElementNS(this.SVG_NS, "line") as SVGLineElement;
        new_line.setAttribute("x1", p_x1.toString());
        new_line.setAttribute("y1", p_y1.toString());
        new_line.setAttribute("x2", p_x2.toString());
        new_line.setAttribute("y2", p_y2.toString());
        new_line.setAttribute("stroke", p_color);
        new_line.setAttribute("stroke-width", p_stroke_width.toString());
        return new_line;
    }

}


